<template>
  <div id="educational-component" :class="['ed-card', `ed-card--${variant}`]">
    <div class="ed-icon">
      <i class="icon-lock" />
    </div>

    <h3 class="ed-title">{{ $t(titleKey) }}</h3>
    <p class="ed-body">{{ $t(bodyKey) }}</p>

    <template v-if="!isOfflineVersion">
      <div class="ed-offer">
        <div class="ed-offer__label">{{ $t('educational.offerLabel') }}</div>

        <div class="ed-offer__price">
          <span class="ed-offer__old">2100€</span>
          <span class="ed-offer__new">1100€</span>
          <span class="ed-offer__badge">−48%</span>
        </div>

        <div class="ed-offer__note">{{ $t('educational.offerNote') }}</div>

        <b-button variant="primary" block :to="{ name: 'purchase-athlisis' }" class="ed-cta">
          {{ $t('educational.ctaPurchase') }}
          <i class="fe-arrow-right tw-ml-1" />
        </b-button>

        <p class="ed-offer__auto">{{ $t('educational.autoApplied') }}</p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    // 'blocked' (default): "you tried to use this, can't" — for gated routes.
    // 'promo': passive upsell — for home and other surfaces students can browse.
    variant: {
      type: String,
      default: 'blocked',
      validator: (v) => ['blocked', 'promo'].includes(v),
    },
  },
  computed: {
    titleKey() {
      if (this.isOfflineVersion) return 'educational.title';
      return this.variant === 'promo' ? 'educational.titlePromo' : 'educational.title';
    },
    bodyKey() {
      if (this.isOfflineVersion) return 'educational.bodyOffline';
      return this.variant === 'promo' ? 'educational.bodyPromo' : 'educational.body';
    },
  },
};
</script>

<style lang="scss" scoped>
.ed-card {
  background: #fff;
  border: 1px solid #e9eaf0;
  border-radius: 16px;
  padding: 3rem 1.5rem;
  text-align: center;

  &--promo {
    padding: 1.75rem 1.25rem;

    .ed-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      margin-bottom: 1rem;

      i { font-size: 22px; }
    }

    .ed-title {
      font-size: 1.15rem;
      margin-bottom: 0.5rem;
    }

    .ed-body {
      font-size: 0.875rem;
      margin-bottom: 1.25rem;
    }

    .ed-offer {
      max-width: none;
    }
  }
}

.ed-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: linear-gradient(135deg, #eef2fa 0%, #dee5f2 100%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;

  i {
    font-size: 28px;
    color: #3155A6;
  }
}

.ed-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1d29;
  margin: 0 0 0.75rem;
}

.ed-body {
  color: #6b7280;
  max-width: 28rem;
  margin: 0 auto 2rem;
  line-height: 1.5;
}

.ed-offer {
  display: block;
  text-align: left;
  margin: 0 auto;
  max-width: 380px;

  &__label {
    font-size: 0.75rem;
    font-weight: 700;
    color: #3155A6;
    margin-bottom: 0.5rem;
  }

  &__price {
    display: flex;
    align-items: baseline;
    gap: 0.625rem;
    margin-bottom: 0.25rem;
  }

  &__old {
    color: #9ca3af;
    text-decoration: line-through;
    font-size: 0.95rem;
  }

  &__new {
    font-size: 2rem;
    font-weight: 800;
    color: #1a1d29;
    line-height: 1;
  }

  &__badge {
    margin-left: auto;
    background: #fee2e2;
    color: #b91c1c;
    font-size: 0.7rem;
    font-weight: 700;
    padding: 0.2rem 0.5rem;
    border-radius: 6px;
    letter-spacing: 0.5px;
  }

  &__note {
    color: #6b7280;
    font-size: 0.825rem;
    margin-bottom: 0.875rem;
  }

  &__auto {
    margin: 0.625rem 0 0;
    text-align: center;
    font-size: 0.75rem;
    color: #9ca3af;
  }
}

.ed-cta {
  margin-top: 1.75rem;
}
</style>
